import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
import * as user from "@/store/modules/user.js";
import * as titlemessage from "@/store/modules/titlemessage.js";
import * as notifications from "@/store/modules/notifications.js";
import * as backbutton from "@/store/modules/backbutton.js";
import * as savedAsssetTableSorting from "@/store/modules/savedAsssetTableSorting.js";

export default new Vuex.Store({
  plugins: [createPersistedState(
    {
      paths:['user']
    }
  )],
  modules: {
    user,
    titlemessage,
    notifications,
    backbutton,
    savedAsssetTableSorting
  },
});
